import React from 'react';

const linkStyle = {
  fontSize: '15px',
  fontWeight: '500',
  color: '#1890ff',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  textDecoration: 'none',
};

// Stored names start with an upload id and a timestamp; a signed link also carries its signature.
export const attachmentName = url => {
  try {
    const name = decodeURIComponent(new URL(url).pathname.split('/').pop() || '');
    return name.replace(/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}_)?(?:\d{13}_)?/i, '') || 'Attachment';
  } catch (error) {
    return 'Attachment';
  }
};

/** Opens a timesheet file, or says so when this release has no link for it (a private file it cannot sign). */
const AttachmentLink = ({ url }) =>
  url ? (
    <a href={url} target="_blank" rel="noopener noreferrer" style={linkStyle}>
      {attachmentName(url)}
    </a>
  ) : (
    <span style={{ ...linkStyle, color: '#8c8c8c' }}>Not available here</span>
  );

export default AttachmentLink;
